import CFG from '../gameLoopConfig.json';
import { generateModifierCombinations } from '../../../data/worldModifiers';

export function expireEffects(s, timestamp) {
  if (s.spellEffects.length > 0) {
    for (let i = s.spellEffects.length - 1; i >= 0; i--) {
      if (timestamp - s.spellEffects[i].startTime >= s.spellEffects[i].duration)
        s.spellEffects.splice(i, 1);
    }
    if (s.spellEffects.length > CFG.spellFxCap) s.spellEffects.length = CFG.spellFxCap;
  }
  if (s.floatingTexts.length > 0) {
    for (let i = s.floatingTexts.length - 1; i >= 0; i--) {
      if (timestamp - s.floatingTexts[i].startTime >= s.floatingTexts[i].duration)
        s.floatingTexts.splice(i, 1);
    }
    if (s.floatingTexts.length > CFG.floatingTextCap) s.floatingTexts.length = CFG.floatingTextCap;
  }
}

export function checkWorldModifier(s, setWorldModifierChoices, setGameState) {
  if ((s.bossKills ?? 0) <= 0) return;
  const modThreshold = Math.floor(s.bossKills / CFG.combat.bossModifierThreshold);
  if (modThreshold > (s.lastModifierAt ?? -1)) {
    s.lastModifierAt = modThreshold;
    setWorldModifierChoices(generateModifierCombinations(3));
    setGameState('modifier');
  }
}

export function updateScore(s, terrainDy) {
  s.bgScrollTotal = (s.bgScrollTotal ?? 0) + terrainDy;
  s.score = Math.floor(s.bgScrollTotal);
}
